module.exports = __webpack_public_path__ + "img/auth-bg.a387f844.png";